<template>
	<div :id="baseId" class="slide_love">
		<div class="slide_header">
			<h1>See What People Are Saying 👀</h1>
			<h2>Stan is the easiest way to start selling online.</h2>
		</div>
		<div class="wall">
			<div class="column">
				<div class="testimonial anim img">
					<img class="main" src="@/assets/images/home/v6/abigail-peugh.png" />
				</div>

				<div class="testimonial anim img">
					<img class="main" src="@/assets/images/home/v6/test-3.png" />
				</div>
				<div class="testimonial anim img">
					<img class="main" src="@/assets/images/home/v6/test-2.png" />
				</div>
			</div>
			<div class="column">
				<div class="testimonial anim img">
					<img class="main" src="@/assets/images/home/v6/jenna.png" />
				</div>
				<div class="testimonial anim img">
					<img class="main" src="@/assets/images/home/v6/test-5.png" />
				</div>
				<div class="testimonial anim img">
					<img class="main" src="@/assets/images/home/v6/test-7.png" />
				</div>
			</div>
			<div class="column">
				<div class="testimonial anim img">
					<img class="main" src="@/assets/images/home/v6/test-10.png" />
				</div>
				<div class="testimonial anim img">
					<img class="main" src="@/assets/images/home/v6/test-8.png" />
				</div>
				<div class="testimonial anim img">
					<img class="main" src="@/assets/images/home/v6/test-9.png" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { computed, defineComponent, getCurrentInstance, ref } from 'vue'
	import { client } from '@/plugins/platform'
	const reviews = []
	export default defineComponent({
		name: 'LandingV6Testimonials',
		props: {
			id: {
				type: [String, Number],
			},
			activeComponent: { type: Boolean },
		},
		setup(props) {
			const isMobile = computed(() => {
				const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
				return client.is.mobile === true || width < 767
			})
			const listReviews = computed(() =>
				reviews
					.map(r => ({ ...r }))
					.sort((a, b) => {
						return isMobile.value
							? a.mobileOrder > b.mobileOrder
								? 1
								: b.mobileOrder > a.mobileOrder
								? -1
								: 0
							: a.order > b.order
							? 1
							: b.order > a.order
							? -1
							: 0
					})
			)
			const goTo = url => {
				window.open(url, '_blank')
			}
			return {
				baseId: `${props.id}`,
				addonId: `${props.id}-add-on`,
				goTo,
			}
		},
	})
</script>
<style lang="scss" scoped>
	.slide_header {
		text-align: center;
		margin-bottom: -30px;
		margin-top: 60px;
		h1 {
			font-size: 36px;
			font-weight: 900;
			margin-bottom: 30px;
		}
		h2 {
			font-size: 18px;
			font-weight: 400;
		}
	}
	.slide_love {
		background: rgb(17, 17, 19);
		background: rgb(238, 238, 249);
		height: fit-content;
		gap: 20px;
		.column {
			&:nth-child(1) {
				transform: translateY(var(--parallax-s2-1));
			}
			&:nth-child(2) {
				transform: translateY(var(--parallax-s2-2));
			}
			&:nth-child(3) {
				transform: translateY(var(--parallax-s2-2));
			}
		}
	}
	.wall {
		margin: 40px auto;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 2vw;
		width: 90%;
		height: 100%;
		padding-top: 60px;
		.column {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
		}
		.profile {
			width: 24vw;
			max-width: 370px;
			padding: 5px;
			flex-shrink: 0;
			background: white;
			border-radius: 20px;
			box-shadow: 0 50px 80px rgba(black, 0.15);
			&:nth-child(2) {
				background-color: red;
				transform: translateY(var(--parallax-1));
			}
		}
		.testimonial {
			width: 22vw;
			max-width: 370px;
			flex-shrink: 0;
			border-radius: 10px;
			box-shadow: 0 50px 80px rgba(black, 0.15);
			position: relative;
			margin-bottom: 2vw;
			background: rgba(white, 0.08);
			color: rgba(white, 0.9);
			//border: 1px solid rgba(white, 0.1);
			background: white;
			color: #131f60;
			font-family: 'Inter', sans-serif !important;
			overflow: hidden;
			padding: 0;
			&.img {
				padding: 0;
				border: none;
				img {
					margin: 0;
					padding: 0;
					width: 100%;
					max-width: 370px;
					//border-radius: 25px;
				}
			}
			video {
				border-radius: 15px;
			}
			.bio {
				display: flex;
				gap: 10px;
				padding: 20px;
				padding-bottom: 20px;
				.avatar {
					width: 40px;
					height: 40px;
					border-radius: 50%;
					background: #f0f0f0;
				}
				.expo {
					h1 {
						font-family: 'Inter', sans-serif !important;
						font-size: 14px;
						margin: 0;
						margin-bottom: 5px;
						font-weight: 800;
						letter-spacing: -0.3px;
					}
					h2 {
						font-family: 'Inter', sans-serif !important;
						font-size: 12px;
						font-weight: 300;
						margin: 0;
						letter-spacing: -0.05px;
					}
				}
			}
			p {
				padding: 20px;
				padding-top: 0;
				font-size: 14px;
				line-height: 130%;
				font-weight: 400;
				letter-spacing: -0.08px;
			}
		}
	}
	// Mobile
	@media screen and (max-width: 800px) {
		.slide_header {
			padding: 0;
		}
		.slide_love {
		}
		.img {
			padding: 0;
			border: none;
			img {
				width: 80vw !important;
				border-radius: 15px;
			}
		}
		video {
			width: 80vw !important;
		}
		.wall {
			display: flex;
			width: 100vw;
			flex-wrap: nowrap;
			overflow-x: scroll;
			overflow-y: hidden;
			justify-content: flex-start;
			padding: 25px 10vw;
			.column {
				justify-content: flex-start;
				display: flex;
				flex-wrap: nowrap;
				flex-direction: row;
				overflow-y: visible;
			}
			.testimonial {
				width: 68vw;
				height: fit-content;
				max-height: 74vh;
				margin: 0 10px;
				box-shadow: 0px 10px 30px rgba(black, 0.05);
				letter-spacing: -0.5px;
				img {
					width: 100% !important;
				}
			}
		}
	}
</style>
